export default __webpack_public_path__ + "static/media/hamburger-gallery.b56dbce6.svg";